import "./App.css";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <HomePage />
    </div>
  );
}

export default App;
